import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        prjName: null, // 项目名称
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入"
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "280",
          fixed: true,
          isShow: true,
        },
        {
          label: "招标编号",
          prop: "bidSectionCode",
          width: "170",
          fixed: true,
        },
        {
          label: "采购计划备案号",
          prop: "采购计划备案号",
          width: "180",
          fixed: true,
        },
        {
          label: "招标人",
          prop: "tenderCorpName",
          width: "250",
        },
        {
          label: "招标代理机构",
          prop: "tenderAgentOrganName",
          width: "250",
        },
        {
          label: "中标人",
          prop: "winningCorpName",
          width: "250",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
    }
  },

  // 接收父组件传递的数据
  props: {

  },

  // 模板编译完成
  mounted() {
  },

  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/projectCgjhba/projectChooseList", {
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 招标公告选择
     * @author shuhua
     */
    fun_TenderNoticeSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面
        this.$parent.fun_SetTenderNotice(e.val);
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
}